export default __webpack_public_path__ + "static/media/placeholder_business01-nl-mobile.71038094.png";